import {
  Directive,
  ElementRef,
  OnInit,
  Renderer2,
  Input,
  Output,
  EventEmitter,
  HostListener,
} from '@angular/core';

@Directive({
  selector: '[appIframeTracker]',
  standalone: false,
})
export class IframeTrackerDirective implements OnInit {
  private iframeMouseOver: boolean;

  @Input() debug: boolean;

  @Output() iframeClick = new EventEmitter<ElementRef>();

  constructor(private el: ElementRef, private renderer: Renderer2) {}

  /**
   * OnInit - add a window blur event handling
   */
  ngOnInit(): void {
    this.renderer.listen(window, 'blur', () => this.onWindowBlur());
  }

  /**
   * Add host listener to native mouse over event handling on iframe
   */
  @HostListener('mouseover')
  private onIframeMouseOver(): void {
    this.iframeMouseOver = true;
    this.resetFocusOnWindow();
  }

  /**
   * Add host listener to native mouse event handling on iframe
   */
  @HostListener('mouseout')
  private onIframeMouseOut(): void {
    this.iframeMouseOver = false;
    this.resetFocusOnWindow();
  }

  /**
   * On Window blur reset focus on window event handling on iframe
   */
  private onWindowBlur(): void {
    if (this.iframeMouseOver) {
      this.resetFocusOnWindow();
      this.iframeClick.emit(this.el);
    }
  }

  /**
   * Reset window focus on set timeout on iframe
   */
  private resetFocusOnWindow(): void {
    setTimeout(() => {
      window.focus();
    }, 100);
  }

  /**
   * Log any messages related to iframe tracker directive if debug mode (boolean) is enabled.
   * @param message - message to be logged
   */
  private log(message: string): void {
    if (this.debug) {
      console.log(message);
    }
  }
}
